
//function validate(token){
 //   const svar = false;
  //  fetch("https://recaptchaenterprise.googleapis.com/v1/projects/fotlyft-v3-1737219985158/assessments?key=AIzaSyClJsZja0iQYPxSwIdp7nCvHcB2n_oXNCg", {
   //         method: "POST",
    //        body: JSON.stringify({
  //            "event": {"token": token,
  //                      "siteKey": "6LcnuLsqAAAAAP_VoLmZoyQwJ7c8jUMElOC83d9v"}
    //        }),
   //         headers: {
   //           "Content-type": "application/json; charset=UTF-8"
   //         }
   //       })
   //       .then((response) => response.json())
   //       .then((response) => {
            // Navigera till tokenProperties.valid
    //        const isValid = response.tokenProperties.valid;
   //         return isValid
   //         if (isValid) {
   //           console.log("Tokenet är giltigt:", isValid);
   //           return true
    //        } else {
    //          console.log("Tokenet är ogiltigt. Botjävel");
    //          return false 
   //         }
    //      })

 // return svar;
//}
function validate(token) {
    return fetch("https://recaptchaenterprise.googleapis.com/v1/projects/fotlyft-v3-1737219985158/assessments?key=AIzaSyClJsZja0iQYPxSwIdp7nCvHcB2n_oXNCg", {
            method: "POST",
            body: JSON.stringify({
                "event": {
                    "token": token,
                    "siteKey": "6LdJ_PgqAAAAAH2Bc6B9WN_Iyz4wUYgkPRk6TVV-"
                }
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        })
        .then(response => response.json())
        .then(response => {
            const isValid = response.tokenProperties.valid;
            console.log(isValid ? "Tokenet är giltigt." : "Tokenet är ogiltigt. Botjävel.");
            return isValid;
        })
        .catch(error => {
            console.error('Error during validation:', error);
            return false;
        });
}

grecaptcha.ready(function() {
    grecaptcha.execute('6LdJ_PgqAAAAAH2Bc6B9WN_Iyz4wUYgkPRk6TVV-', {action: 'submit'}).then(function(token) {
        validate(token).then(isValid => {
            if (isValid) {
                console.log("123")
                // Lägg till logik här för vad som ska hända om tokenet är giltigt
            } else {
                window.location.href = "https://stackoverflow.com"
                // Lägg till logik här för vad som ska hända om tokenet inte är giltigt
            }
        });
    });
});

 